import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button, FlexBox } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faPaperclip } from '@fortawesome/pro-light-svg-icons';
import illustration from 'assets/Images/illustration.svg';
import { remindLater } from 'Requests/Request_Methods/miscMethods';
import { sendLinkViaEmail } from 'Requests/Request_Methods/campaignMethods';
import './LandingPage.scss';

const LandingPage = () => {
  const history = useHistory();
  const location = useLocation();
  const { is_reminded, notification_id } = location.state;
  const { campaignId } = useParams<{ campaignId: string }>();

  const copyLink = () => {
    const text = document.getElementById('copy-link-input') as HTMLInputElement;
    if (!text) return;
    text.select();
    text.setSelectionRange(0, 99999999);
    navigator.clipboard
      .writeText(text.value)
      .then(() => {
        toast.success('Link copied!');
      })
      .catch(err => {
        toast.error('Failed to copy the link.');
      });
  };
  const sendLink = () => {
    sendLinkViaEmail(campaignId)
      .then(res => {
        toast.success('Link sent successfully!');
      })
      .catch(err => {
        if ('detail' in err) toast.error(err.detail);
        else toast.error('Failed to send the link.');
      });
  };

  const handleRemindLater = () => {
    remindLater(notification_id)
      .then(res => {
        toast.success('Reminder set!');
      })
      .catch(err => {
        if ('detail' in err) toast.error(err.detail);
        else toast.error('Failed to set the reminder.');
      });
  };
  return (
    <FlexBox UNSAFE_className="LandingPage" flexDirection="column" alignItems="flex-start">
      <button onClick={() => history.goBack()} className="back_btn">
        <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '24px' }} />
      </button>
      <FlexBox
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        UNSAFE_className="landing_content"
      >
        <FlexBox
          UNSAFE_className="illustartion_wrapper"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="8px"
        >
          <img src={illustration} alt="illustartion" className="illustartion" />
          <div>
            <h3 className="heading">This feature needs a bit more screen space</h3>
            <p className="desc">
              For the best experience, this feature is only available on desktop. We’ll help you get
              there.
            </p>
          </div>
        </FlexBox>
        <FlexBox
          flexDirection="column"
          alignItems="center"
          UNSAFE_className="action_btns"
          gap="16px"
        >
          <Button kind="primary" size="l" weight="bold" onClick={sendLink}>
            Send me this link via email
          </Button>
          {!is_reminded && (
            <Button
              kind="default"
              size="l"
              weight="bold"
              UNSAFE_className="reminder"
              onClick={handleRemindLater}
            >
              Remind me later on desktop
            </Button>
          )}
        </FlexBox>
        <FlexBox justifyContent="center" UNSAFE_className="action_btns">
          <input
            type="text"
            value={`${window.location.origin}/generated-campaign/${campaignId}`}
            id="copy-link-input"
            style={{ display: 'none' }}
          />
          <Button
            kind="link"
            size="l"
            weight="bold"
            iconLeft={<FontAwesomeIcon icon={faPaperclip} />}
            onClick={copyLink}
          >
            Copy link
          </Button>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
};

export default LandingPage;
